import { useEffect, useState } from 'react'
import CloseIcon from '@material-ui/icons/Close'
import MenuIcon from '@material-ui/icons/Menu'
import { projects, skills } from '../../data'
import './Navbar.css'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') setIsOpen(false)
    }

    window.addEventListener('keydown', handleEscape)

    return () => window.removeEventListener('keydown', handleEscape)
  }, [])

  const closeMenu = () => setIsOpen(false)

  const toggleMenu = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setIsOpen((open) => !open)
  }

  return (
    <nav className={`center nav ${isOpen ? 'nav--open' : ''}`} aria-label='Primary navigation'>
      <button
        className='nav__toggle'
        type='button'
        aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
        aria-expanded={isOpen}
        aria-controls='primary-navigation'
        onClick={toggleMenu}
      >
        {isOpen ? <CloseIcon fontSize='small' /> : <MenuIcon fontSize='small' />}
      </button>

      <ul className='nav__list' id='primary-navigation'>
        {projects.length ? (
          <li className='nav__list-item'>
            <a href='#projects' className='link link--nav' onClick={closeMenu}>
              Projects
            </a>
          </li>
        ) : null}

        {skills.length ? (
          <li className='nav__list-item'>
            <a href='#skills' className='link link--nav' onClick={closeMenu}>
              Skills
            </a>
          </li>
        ) : null}

        <li className='nav__list-item'>
          <a href='#contact' className='link link--nav' onClick={closeMenu}>
            Contact
          </a>
        </li>
      </ul>
    </nav>
  )
}

export default Navbar
